module.exports = __webpack_public_path__ + "media/images/pc/top/kodawari_maedori@3x-9730a4e3ecd0b014e54b1ff6ebeeb691.webp";